import { FC, useState } from 'react';
import {
	Button,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from 'src/components/ui';
import { ICatalog } from 'src/lib/schemas';

export interface ProductDeleteModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: (data: ICatalog) => void;
	data?: ICatalog;
}

const ProductDeleteModal: FC<ProductDeleteModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	data,
}) => {
	const [isDeleting, setIsDeleting] = useState(false);

	if (!data) return null;

	const handleClose = () => {
		if (isDeleting) return;
		onClose();
	};

	const handleDelete = async () => {
		setIsDeleting(true);
		await onConfirm(data);
		setIsDeleting(false);
		onClose();
	};

	return (
		<Modal isOpen={isOpen} onClose={handleClose}>
			<ModalOverlay zIndex={1800} />
			<ModalContent
				containerProps={{
					zIndex: 1900,
				}}
			>
				<ModalHeader>
					<Heading>Delete Catalog</Heading>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text mb={2}>
						Are you sure you want to delete &ldquo;{data.name}
						&rdquo;?
					</Text>
				</ModalBody>
				<ModalFooter>
					<Button variant="outline" onClick={handleClose}>
						Cancel
					</Button>
					<Button
						colorScheme="red"
						ml={4}
						onClick={handleDelete}
						isLoading={isDeleting}
						loadingText="Deleting..."
					>
						Delete
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default ProductDeleteModal;
